import React, { FC, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { actions, selectors } from '../../redux/app/redux'
import { app } from '../../configuration'

import Feedback from '.'

const FeedbackWrapper: FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const feedback = useSelector(selectors.feedback)
  const dispatch = useDispatch()

  const onClose = useCallback(() => {
    setIsOpen(false)
    dispatch(actions.setFeedback(null))
  }, [dispatch])

  useEffect(() => {
    if (feedback) {
      setIsOpen(true)
      setTimeout(() => {
        onClose()
      }, app.FEEDBACK_DURATION)
    }
  }, [feedback, onClose])

  return <Feedback isOpen={isOpen} text={feedback || ''} onClose={onClose} />
}

export default FeedbackWrapper
